import React from 'react';
import { bool, node, string } from 'prop-types';

import ProseSpinner from '../ProseSpinner/ProseSpinner';
import { Wrap, DimmedContent, IndicatorLayer } from './StepTransitionOverlayStyles';

const renderIndicator = (size) => <ProseSpinner size={size} />;

const StepTransitionOverlay = ({
  loading, size, children, label,
}) => (
  <Wrap>
    <DimmedContent $loading={loading} aria-busy={loading || undefined} aria-hidden={loading || undefined}>
      {children}
    </DimmedContent>
    {loading && (
      <IndicatorLayer role="status" aria-live="polite" aria-label={label}>
        {renderIndicator(size)}
      </IndicatorLayer>
    )}
  </Wrap>
);

StepTransitionOverlay.propTypes = {
  loading: bool,
  size: string,
  label: string,
  children: node.isRequired,
};

StepTransitionOverlay.defaultProps = {
  loading: false,
  size: '5rem',
  label: 'Loading',
};

export default StepTransitionOverlay;
